import React from 'react';

const PageHeader = ({ title, description, children }) => {
  return (
    <div className="h-20 px-6 border-b border-gray-200 flex items-center justify-between bg-white sticky top-0 z-10 w-full shrink-0 gap-4">
      <div>
        <h1 className="text-xl font-bold text-gray-900 leading-none text-left">
          {title}
        </h1>
       
      </div>
      {children && (
        <div className="flex items-center gap-3">
          {children}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
